"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "main-settings-container" };
const _hoisted_2 = {
    key: 0,
    class: "upgrade-message-overlay"
};
const _hoisted_3 = {
    key: 1,
    class: "settings-card-container"
};
const _hoisted_4 = { class: "settings-title-wrapper" };
const _hoisted_5 = { class: "settings-item" };
const _hoisted_6 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_7 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_8 = { class: "settings-input oplus-form-switch" };
const _hoisted_9 = ["checked"];
const _hoisted_10 = { class: "settings-item" };
const _hoisted_11 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_12 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_13 = { class: "settings-input oplus-form-switch" };
const _hoisted_14 = ["checked"];
const _hoisted_15 = { class: "settings-item" };
const _hoisted_16 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_17 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_18 = { class: "settings-input oplus-form-switch" };
const _hoisted_19 = ["checked"];
const _hoisted_20 = {
    key: 2,
    class: "loading"
};
const _hoisted_21 = {
    key: 3,
    class: "submit"
};
const vue_3 = require("vue");
const OplusChatIcon_vue_1 = __importDefault(require("../../assets/icons/OplusChatIcon.vue"));
const AlertModal_vue_1 = __importDefault(require("../../../vue/AlertModal.vue"));
const provider_1 = require("../../../provider/provider");
const InfoIcon_vue_1 = __importDefault(require("../../../vue/icons/InfoIcon.vue"));
const common_1 = require("../../../common/common");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ChatSettings',
    setup(__props, { expose: __expose }) {
        const viewModel = (0, vue_3.inject)(provider_1.chatSettingsViewModelInjectKey);
        const controller = (0, vue_3.inject)(provider_1.chatSettingsControllerInjectKey);
        const alertModal = (0, vue_3.ref)(null);
        const blockStaffCheck = (0, vue_3.ref)(null);
        const blockStaffFileAttachmentCheckbox = (0, vue_3.ref)(null);
        const allowMembershipForStaffOutsideBranchCheck = (0, vue_3.ref)(null);
        const savedSettings = (0, vue_3.ref)("");
        (0, vue_3.onMounted)(async () => {
            if (!viewModel || !controller) {
                alert('Required injections not found.');
                return;
            }
            if (!viewModel.value.settings) {
                await controller.getChatSettings(viewModel.value.id);
            }
            savedSettings.value = JSON.stringify(getSavedSettings());
        });
        const showSettings = (0, vue_3.computed)(() => {
            return viewModel?.value.showSettings || false;
        });
        const showUpgradeMessage = (0, vue_3.computed)(() => {
            return viewModel?.value.showUpgradeMessage ?? true;
        });
        const blockStaffChecked = (0, vue_3.computed)(() => {
            return viewModel?.value.settings?.blockStaffRoomCreation ?? false;
        });
        const allowMembershipForStaffOutsideBranchChecked = (0, vue_3.computed)(() => {
            return viewModel?.value.settings?.allowMembershipForStaffOutsideBranch ?? false;
        });
        const blockStaffFileAttachmentChecked = (0, vue_3.computed)(() => {
            return viewModel?.value.settings?.blockStaffFileAttachment ?? false;
        });
        const isLoading = (0, vue_3.ref)(false);
        const loadingClass = (0, vue_3.computed)(() => {
            return {
                "loading": isLoading.value,
            };
        });
        async function handleSubmit() {
            if (isLoading.value || !controller || !viewModel || viewModel.value.showUpgradeMessage) {
                return false;
            }
            const body = getLocalSettings();
            try {
                isLoading.value = true;
                await controller.patchChatSettings(viewModel.value.id, body);
                (0, common_1.showSaveSuccessSnackbar)();
                savedSettings.value = JSON.stringify(body);
                return true;
            }
            catch (e) {
                alertModal.value?.alert(e);
                return false;
            }
            finally {
                isLoading.value = false;
            }
        }
        function getLocalSettings() {
            return {
                blockStaffRoomCreation: blockStaffCheck.value?.checked ?? blockStaffChecked.value,
                allowMembershipForStaffOutsideBranch: allowMembershipForStaffOutsideBranchCheck.value?.checked ?? allowMembershipForStaffOutsideBranchChecked.value,
                blockStaffFileAttachment: blockStaffFileAttachmentCheckbox.value?.checked ?? blockStaffFileAttachmentChecked.value,
            };
        }
        function getSavedSettings() {
            const settings = viewModel?.value.settings;
            return {
                blockStaffRoomCreation: settings?.blockStaffRoomCreation ?? false,
                allowMembershipForStaffOutsideBranch: settings?.allowMembershipForStaffOutsideBranch ?? false,
                blockStaffFileAttachment: settings?.blockStaffFileAttachment ?? false,
            };
        }
        function hasUnsavedChanges() {
            if (!savedSettings.value || showUpgradeMessage.value) {
                return false;
            }
            return JSON.stringify(getLocalSettings()) !== savedSettings.value;
        }
        __expose({
            hasUnsavedChanges,
            saveSettings: handleSubmit,
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(AlertModal_vue_1.default, {
                    ref_key: "alertModal",
                    ref: alertModal
                }, null, 512 /* NEED_PATCH */),
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (showUpgradeMessage.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                                (0, vue_2.createElementVNode)("div", { class: "upgrade-message-card text-center" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "modal-title h4" }, "アップグレードが必要です"),
                                    (0, vue_2.createElementVNode)("br"),
                                    (0, vue_2.createElementVNode)("span", null, "この機能を使用するためには"),
                                    (0, vue_2.createElementVNode)("span", { class: "pro-label chat-label m-2" }),
                                    (0, vue_2.createElementVNode)("span", null, "プランへアップグレードが必要です")
                                ], -1 /* CACHED */)
                            ]))]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (showSettings.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                            (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                (0, vue_2.createVNode)(OplusChatIcon_vue_1.default),
                                _cache[1] || (_cache[1] = (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "チャット", -1 /* CACHED */))
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                    _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "ルーム", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[2] || (_cache[2] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフがルーム作成をできなくする")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_8, [
                                    (0, vue_2.createElementVNode)("input", {
                                        ref_key: "blockStaffCheck",
                                        ref: blockStaffCheck,
                                        checked: blockStaffChecked.value,
                                        type: "checkbox"
                                    }, null, 8 /* PROPS */, _hoisted_9),
                                    _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                    _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "ルーム", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "管理者は、所属拠点に関係なく、全拠点のスタッフをルームに追加できます。")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_13, [
                                    (0, vue_2.createElementVNode)("input", {
                                        ref_key: "allowMembershipForStaffOutsideBranchCheck",
                                        ref: allowMembershipForStaffOutsideBranchCheck,
                                        checked: allowMembershipForStaffOutsideBranchChecked.value,
                                        type: "checkbox"
                                    }, null, 8 /* PROPS */, _hoisted_14),
                                    _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                    _cache[9] || (_cache[9] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "メッセージ", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフがメッセージにファイルを添付・送信できないようにする")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_18, [
                                    (0, vue_2.createElementVNode)("input", {
                                        ref_key: "blockStaffFileAttachmentCheckbox",
                                        ref: blockStaffFileAttachmentCheckbox,
                                        checked: blockStaffFileAttachmentChecked.value,
                                        type: "checkbox"
                                    }, null, 8 /* PROPS */, _hoisted_19),
                                    _cache[10] || (_cache[10] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ])
                        ]))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_20, " loading... ")),
                    (showSettings.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_21, [
                            (0, vue_2.createElementVNode)("button", {
                                class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn oplus-save-btn", loadingClass.value]),
                                onClick: handleSubmit
                            }, "保存", 2 /* CLASS */)
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true)
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
